// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_tracking_ui_styles" + "." + "e73a68c6" + ".chunk.css";
};